<template>
    <div style="" class="father-sty" :style="{ 'height': (screen.height - 180) + 'px' }">
      <el-row :gutter="50">
        <el-col v-for="(item,index) in peopleArr" :span="12" :key="index">
          <div class="peo-sty">
            <el-row>
              <el-col :span="12">
                <p>{{item.F_RealName}}</p>
              </el-col>
              <el-col :span="12">
                <p>区域：{{item.F_Region}}</p>
                <p>联系方式：<span>{{item.F_MobilePhone}}</span></p>
              </el-col>
            </el-row>
          </div>
        </el-col>

      </el-row>
      <!--<div class="about-box">-->
        <!--<div>-->
          <!--<h1>万达石化商城</h1>-->
          <!--<p>行政部：0546—6099665</p>-->
          <!--<p>邮箱：wdsh@wandashihua.com</p>-->
          <!--<p>传真：0546—6096678</p>-->
          <!--<p>地址：中国山东省东营市河口区东营港经济开发区港北一路11号</p>-->
          <!--<p>邮编：257200</p>-->
        <!--</div>-->
      <!--</div>-->
      <div class="ewm-box" v-if="visibleEwm">
        <div>
          <div class="ewm">
            <div style="position: relative;">
              <img src="/static/images/HomeTH/ios.png" style='width: 200px;height: 200px'>
              <p class="closeE" @click="visibleEwm = false">关闭</p>
            </div>
          </div>
          <p>微信扫一扫下载</p>
          <p>万达石化商城APP</p>
        </div>
      </div>
    </div>
</template>

<script>
  // import $ from 'jquery'
  // import signalR from 'signalr'
    export default {
      props: {
        screen: {
          type: Object,
          default: () => {
          }
        },
      },
      data() {
        return {

          url:{
            GetSalesUserInfos:SZH.assets.api + '/Custom/GetSalesUserInfos',
          },
          peopleArr:[],
          fullscreenLoading:false,
          visibleEwm:true,
        }
      },
      methods: {
        GetCustomAuthType(){
          let self = this;
          self.$http.post(self.url.GetSalesUserInfos,{}).then(result=>{
            if(result.state == 1){
              self.peopleArr = result.data;
            }else{
              self.peopleArr = []
            }
          })
        },




      },
      computed: {},
      components: {},
      mounted(){
        this.GetCustomAuthType();

      }
    }
</script>

<style scoped>
  .closeE{
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 12px;
    color: #000 !important;
    font-weight: 400 !important;
    cursor: pointer;
  }
  .father-sty{
    width: 1300px;margin: 0px auto;
    padding-left: 0px;
    padding-top: 40px;
    /*height: 100%;*/
    overflow-x: hidden;
    overflow-y: scroll;
    position: relative;
    scrollbar-color: transparent transparent;
　　scrollbar-track-color: transparent;
　　-ms-scrollbar-track-color: transparent;
  }
  .father-sty::-webkit-scrollbar {
    width: 4px;
    /*height: 4px;*/
  }
  .father-sty::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0);
    background: rgba(0,0,0,0);
  }
  .father-sty::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0);
    border-radius: 0;
    background: rgba(0,0,0,0);

  }
  .peo-sty{
    border-bottom: 4px solid #fff;
    padding: 20px 0px;
  }
  .peo-sty p{
    font-weight: 600;
    font-size: 18px;
    margin-top: 5px;
    color: #fff;
  }
  .peo-sty p span{
    color: #EF7377;
  }
  .about-box{
    display: flex;
    margin-top: 150px;
  }
  .about-box>div{
    flex:1
  }
  .about-box>div h1{
    font-size: 56px;
    font-weight: 600;
    color: #fff;
  }
  .about-box>div p{
    font-size: 28px;
    color: #ccc;
    font-weight: 600;
  }
  .ewm-box{
    display: flex;
    justify-content: end;
    position: fixed;
    padding-top: 10px;
    right: 20px;
    bottom: 20px;
  }
  .ewm-box p{
    font-size: 14px;
    font-weight: 600;
    color: #ccc;
    text-align: center;
  }
  .ewm{
    display: flex;
    align-items: center;
  }

  @media only screen and (max-width: 1366px) {
    .peo-sty p{
      font-weight: 600;
      font-size: 14px;
      margin-top: 5px;
      color: #fff;
    }
    .father-sty{
      padding-top: 20px;
      padding-left: 250px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/HomeAbout/HomeAbout.vue